import { ATTEMPT_SUMMARY_TYPE } from '@cont/Quiz/constants';
import {
  getAnsweredQuestionCount,
  getMarkedAndAttemptedQuestionCount,
  getMarkedQuestionCount,
  getNotVisitedQuestions,
  getUnansweredQuestionCount
} from '@cont/Quiz/utils';

export const EMPTY_NTA_SECTION_COUNTS = {
  notVisited: 0,
  notAnswered: 0,
  answered: 0,
  markedForReview: 0,
  answeredMarked: 0
};

export const getNtaSectionCounts = (
  sectionUID,
  {
    answersBySection,
    maxAnswerableQuestionBySection,
    markedQuestionsBySection,
    unansweredQuestionsBySection
  }
) => {
  if (!sectionUID) {
    return EMPTY_NTA_SECTION_COUNTS;
  }

  const summaryType = ATTEMPT_SUMMARY_TYPE.SECTION;
  const sectionScope = { onGoingSectionUID: sectionUID, summaryType };

  const markedAndAttempted = getMarkedAndAttemptedQuestionCount({
    markedQuestionsBySection,
    answersBySection,
    ...sectionScope
  });

  const answered =
    getAnsweredQuestionCount({
      answersBySection,
      ...sectionScope
    }) - markedAndAttempted;

  const markedForReview = getMarkedQuestionCount({
    markedQuestionsBySection,
    maxAnswerableQuestionBySection,
    answersBySection,
    ...sectionScope
  });

  const notAnswered = getUnansweredQuestionCount({
    unansweredQuestionsBySection,
    maxAnswerableQuestionBySection,
    answersBySection,
    ...sectionScope
  });

  const notVisited = getNotVisitedQuestions({
    maxAnswerableQuestionBySection,
    markedQuestionsBySection,
    unansweredQuestionsBySection,
    answersBySection,
    ...sectionScope
  });

  return {
    notVisited: Math.max(0, notVisited),
    notAnswered,
    answered,
    markedForReview,
    answeredMarked: markedAndAttempted
  };
};
